// SEO Configuration for Quicklish
export const SEO_CONFIG = {
    // Site Information
    siteName: "Quicklish",
    siteUrl: process.env.REACT_APP_SITE_URL || "https://myenglishgurukul.com",
    description: "Quicklish - Quickly learn English online! Quick English learning with AI-powered conversations, grammar practice, vocabulary building, and interactive lessons. Master English speaking, writing, and comprehension with personalized learning.",

    // Default Meta Tags
    defaultTitle: "Quicklish: Quick English Learning | Quickly Learn English Online Free",
    titleTemplate: "%s | Quicklish - Quick English Learning",

    // Keywords (Primary Focus)
    keywords: [
        // PRIMARY TARGET KEYWORDS (High Priority)
        "Quick english",
        "Quicklish",
        "Quickly learn english",
        "Quick english learning",
        "Quick english app",
        "Quick english lessons",
        "Quick english course",
        "Quick english practice",
        "Quick english speaking",
        "Quick english grammar",
        // PRIMARY HIGH-VOLUME KEYWORDS
        "learn english online",
        "english learning app",
        "english grammar practice",
        "english conversation practice",
        "ai english tutor",
        "english vocabulary builder",
        "free english lessons",
        "english course online",
        "speak english fluently",
        "english tutor online",
        "improve english skills",
        "english speaking course",
        "english for beginners free",
        "learn english conversation",
        "english practice app",
        "english language course",
        "online english classes",
        "english grammar course",
        "english vocabulary app",
        "learn english fast",
        "english pronunciation app",
        "english writing course",
        "business english course",
        "english communication skills",
        "ielts english preparation",
        "toefl english course",
        "spoken english classes",

        // QUESTION-BASED KEYWORDS (High Search Volume)
        "how to learn english fast",
        "how to improve english speaking",
        "how to speak english fluently",
        "how to learn english at home",
        "how to improve english vocabulary",
        "how to practice english conversation",
        "how to learn english grammar",
        "how to improve english pronunciation",
        "how to learn english online for free",
        "how to speak english confidently",
        "how to improve english writing skills",
        "how to learn english quickly",
        "how to practice english speaking alone",
        "how to master english language",
        "how to learn business english",
        "how to improve english listening skills",
        "how to learn english phrases",
        "how to speak english without accent",
        "how to learn english tenses",
        "how to improve english communication",

        // WHAT QUESTIONS
        "what is the best way to learn english",
        "what is english grammar",
        "what are english tenses",
        "what is present perfect tense",
        "what are modal verbs",
        "what is passive voice",
        "what are phrasal verbs",
        "what is conditional sentence",
        "what are english idioms",
        "what is subject verb agreement",

        // WHY QUESTIONS  
        "why learn english language",
        "why is english grammar important",
        "why english is global language",
        "why practice english conversation",

        // WHERE QUESTIONS
        "where to learn english online",
        "where to practice english speaking",
        "where to find english tutor",
        "where to learn english grammar",

        // WHEN QUESTIONS
        "when to use present perfect tense",
        "when to use past tense",
        "when to use articles in english",
        "when to use prepositions",

        // CAN QUESTIONS
        "can i learn english online",
        "can i speak english fluently",
        "can ai help learn english",
        "can i improve english at home",

        // SPECIFIC SKILL KEYWORDS
        "english speaking practice",
        "english writing skills",
        "english pronunciation",
        "english lessons free",
        "english language learning",
        "english for beginners",
        "advanced english course",
        "english comprehension",
        "english grammar rules",
        "english sentence formation",
        "english tenses practice",
        "english vocabulary building",
        "english phrasal verbs",
        "english idioms and phrases",
        "english reading comprehension",
        "english listening practice",
        "english conversation topics",
        "english speaking exercises",
        "english grammar exercises",
        "english pronunciation guide",

        // LOCATION-BASED KEYWORDS
        "learn english in india",
        "english speaking course india",
        "online english tutor india",
        "english classes near me",
        "english learning app india",
        "free english course india",

        // LONG-TAIL KEYWORDS (Very Specific)
        "improve english speaking at home",
        "best free english learning app 2024",
        "english conversation practice for beginners",
        "learn english grammar rules easily",
        "english pronunciation exercises with audio",
        "business english conversation practice",
        "english interview preparation course",
        "daily english conversation topics",
        "english speaking practice with ai",
        "learn english through conversation",
        "english grammar practice exercises",
        "improve english vocabulary daily",
        "english learning platform online",
        "interactive english lessons free",
        "english fluency training program",
        "personalized english learning",
        "english conversation with ai chatbot",
        "smart english learning app",
        "english language learning software",
        "online english speaking course",

        // AI-FOCUSED KEYWORDS
        "ai english teacher",
        "artificial intelligence english learning",
        "chatbot english practice",
        "smart english learning app",
        "ai powered english tutor",
        "machine learning english course",
        "english learning with artificial intelligence",
        "ai conversation practice english",
        "intelligent english learning system",

        // EXAM/TEST KEYWORDS
        "english test preparation",
        "ielts speaking practice",
        "toefl preparation online",
        "english proficiency test",
        "cambridge english course",
        "english certification course",
        "english exam preparation",

        // DIFFICULTY LEVEL KEYWORDS
        "beginner english lessons",
        "intermediate english course",
        "advanced english learning",
        "basic english grammar",
        "elementary english practice",

        // TIME-BASED KEYWORDS  
        "learn english in 30 days",
        "daily english practice",
        "english lessons every day",
        "quick english learning",
        "english practice 15 minutes daily"
    ],

    // Social Media
    social: {
        twitter: "@myenglishgurukul",
        facebook: "myenglishgurukul",
        instagram: "myenglishgurukul",
        linkedin: "company/myenglishgurukul",
        youtube: "@myenglishgurukul"
    },

    // Business Information
    business: {
        name: "Quicklish",
        type: "Educational Technology",
        address: {
            streetAddress: "",
            addressLocality: "India",
            addressRegion: "",
            postalCode: "",
            addressCountry: "IN"
        },
        phone: "",
        email: "support@myenglishgurukul.com"
    },

    // Author Information
    author: {
        name: "Quicklish Team",
        url: "https://myenglishgurukul.com/about"
    }
};

// Page-specific SEO Templates
export const PAGE_SEO = {
    home: {
        title: "Quicklish: Quick English Learning | Quickly Learn English Online Free with AI",
        description: "Quicklish - Quickly learn English online! Master English with our AI-powered learning platform. Quick English lessons, grammar practice, vocabulary building, and conversation practice. Start your quick English learning journey today!",
        keywords: [
            "Quick english",
            "Quicklish",
            "Quickly learn english",
            "Quick english learning",
            "Quick english app",
            "learn english online free",
            "english learning platform",
            "ai english tutor",
            "english grammar practice",
            "english conversation practice",
            "hindi to english",
            "bengali to english",
            "marathi to english",
            "telugu to english",
            "tamil to english",
            "gujrati to english"

        ],
        canonicalUrl: "/",
        structuredData: "WebSite"
    },

    grammar: {
        title: "English Grammar Practice | Interactive Grammar Lessons & Exercises",
        description: "Master English grammar with interactive lessons, practice exercises, and AI-powered feedback. Learn present tense, past tense, articles, prepositions, and more. Perfect for all levels.",
        keywords: [
            "english grammar practice",
            "grammar exercises online",
            "english grammar rules",
            "grammar lessons",
            "present tense practice",
            "past tense exercises",
            // QUESTION-BASED GRAMMAR KEYWORDS
            "how to learn english grammar",
            "how to improve english grammar",
            "how to practice grammar online",
            "what is english grammar",
            "what are english tenses",
            "what is present perfect tense",
            "what is past perfect tense",
            "what are modal verbs",
            "what is passive voice",
            "what are phrasal verbs",
            "when to use present tense",
            "when to use past tense",
            "when to use future tense",
            "when to use articles a an the",
            "how to use prepositions correctly",
            "how to form questions in english",
            "how to use conditional sentences",
            "english tenses practice online",
            "english grammar test online",
            "basic english grammar rules",
            "advanced english grammar course",
            "english grammar for beginners",
            "grammar practice exercises",
            "english verb tenses practice",
            "english sentence structure",
            "subject verb agreement rules",
            "english punctuation rules"
        ],
        canonicalUrl: "/grammar",
        structuredData: "Course"
    },

    sentences: {
        title: "English Sentence Practice | Build Speaking & Writing Skills",
        description: "Practice English sentence formation with interactive exercises. Improve your speaking and writing skills with guided sentence building activities and instant feedback.",
        keywords: [
            "english sentence practice",
            "sentence formation",
            "english writing practice",
            "sentence building exercises",
            "improve english writing",
            // QUESTION-BASED SENTENCE KEYWORDS
            "how to make sentences in english",
            "how to write good sentences",
            "how to form questions in english",
            "how to write complex sentences",
            "how to improve sentence structure",
            "how to write better sentences",
            "what is sentence structure",
            "what are types of sentences",
            "how to combine sentences",
            "how to write compound sentences",
            "english sentence patterns",
            "sentence construction practice",
            "english writing exercises",
            "daily sentence practice",
            "sentence formation rules",
            "english composition practice"
        ],
        canonicalUrl: "/sentences",
        structuredData: "Course"
    },

    dictionary: {
        title: "English Dictionary & Vocabulary Builder | Learn New Words Daily",
        description: "Expand your English vocabulary with our interactive dictionary. Learn new words, meanings, pronunciations, and usage examples. Build your word power systematically.",
        keywords: [
            "english dictionary online",
            "vocabulary builder",
            "learn new english words",
            "english word meanings",
            "vocabulary practice",
            // QUESTION-BASED VOCABULARY KEYWORDS
            "how to improve english vocabulary",
            "how to learn new words daily",
            "how to remember english words",
            "how to build vocabulary fast",
            "how to use new words in sentences",
            "what are synonyms and antonyms",
            "how to learn word meanings",
            "how to expand vocabulary",
            "best way to learn english words",
            "daily vocabulary practice",
            "english words with meanings",
            "vocabulary building exercises",
            "english word lists",
            "advanced english vocabulary",
            "common english words",
            "english vocabulary for beginners"
        ],
        canonicalUrl: "/dictionary",
        structuredData: "WebApplication"
    },

    conversations: {
        title: "AI English Conversation Practice | Improve Speaking Skills",
        description: "Practice English conversation with AI tutors. Improve your speaking skills, pronunciation, and fluency through interactive dialogue sessions. Available 24/7.",
        keywords: [
            "english conversation practice",
            "ai conversation practice",
            "english speaking practice",
            "conversation skills",
            "english dialogue practice",
            // QUESTION-BASED CONVERSATION KEYWORDS
            "how to practice english conversation",
            "how to improve conversation skills",
            "how to speak english confidently",
            "how to start english conversation",
            "how to practice speaking alone",
            "what to say in english conversation",
            "how to have fluent conversation",
            "how to improve english fluency",
            "english conversation topics",
            "daily conversation practice",
            "english speaking exercises",
            "conversation practice with ai",
            "english chat practice",
            "spoken english practice",
            "english communication skills",
            "real life conversation practice"
        ],
        canonicalUrl: "/conversations",
        structuredData: "Course"
    },

    login: {
        title: "Login to My English Gurukul | Access Your Learning Dashboard",
        description: "Sign in to your English learning account. Access personalized lessons, track your progress, and continue your English learning journey.",
        keywords: [
            "english learning login",
            "student dashboard",
            "english course access"
        ],
        canonicalUrl: "/login",
        noIndex: true
    },

    signup: {
        title: "Join My English Gurukul | Start Learning English for Free",
        description: "Create your free account and start learning English today. Join thousands of students improving their English skills with our AI-powered platform.",
        keywords: [
            "join english course",
            "free english learning",
            "english course signup",
            "start learning english"
        ],
        canonicalUrl: "/signup",
        structuredData: "WebApplication"
    },

    blog: {
        title: "English Learning Blog | Expert Tips, Grammar Guides & Success Stories",
        description: "Discover expert English learning tips, grammar guides, vocabulary building techniques, and inspiring success stories from our AI-powered learning platform. Boost your English skills today!",
        keywords: [
            "english learning blog",
            "english learning tips",
            "grammar guides",
            "vocabulary building",
            "english success stories",
            "language learning blog",
            "english study tips",
            "how to learn english",
            "english learning strategies",
            "english improvement tips",
            "english practice exercises",
            "english learning motivation",
            "best english learning methods",
            "english fluency tips",
            "english conversation tips",
            "english writing tips",
            "english pronunciation tips",
            "english grammar blog",
            "vocabulary expansion",
            "english learning resources",
            "ai english learning",
            "english teacher blog",
            "english lessons online",
            "learn english fast",
            "improve english skills"
        ],
        canonicalUrl: "/blog",
        structuredData: "Blog"
    },

    "blog-post": {
        title: "English Learning Article | My English Gurukul Blog",
        description: "Read expert English learning tips, grammar explanations, vocabulary guides, and success stories to improve your English skills.",
        keywords: [
            "english learning article",
            "english tips",
            "grammar explanation",
            "vocabulary guide",
            "english lesson",
            "learning english",
            "english improvement",
            "english study guide"
        ],
        canonicalUrl: "/blog",
        structuredData: "Article"
    }
};

// Structured Data Templates
export const STRUCTURED_DATA = {
    website: {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Quicklish - Quick English Learning",
        "alternateName": ["Quicklish", "Quick English", "Quickly Learn English"],
        "url": SEO_CONFIG.siteUrl,
        "description": SEO_CONFIG.description,
        "keywords": "Quick english, Quicklish, Quickly learn english, Quick english learning, English learning app",
        "inLanguage": "en",
        "potentialAction": {
            "@type": "SearchAction",
            "target": {
                "@type": "EntryPoint",
                "urlTemplate": `${SEO_CONFIG.siteUrl}/search?q={search_term_string}`
            },
            "query-input": "required name=search_term_string"
        },
        "publisher": {
            "@type": "Organization",
            "name": SEO_CONFIG.siteName,
            "url": SEO_CONFIG.siteUrl,
            "logo": {
                "@type": "ImageObject",
                "url": `${SEO_CONFIG.siteUrl}/logo-512x512.png`,
                "width": 512,
                "height": 512
            }
        }
    },

    course: {
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "English Language Learning Course",
        "description": "Comprehensive English language learning with grammar, vocabulary, conversation practice and AI-powered feedback",
        "provider": {
            "@type": "Organization",
            "name": SEO_CONFIG.siteName,
            "url": SEO_CONFIG.siteUrl
        },
        "educationalLevel": "Beginner, Intermediate, Advanced",
        "inLanguage": "en",
        "courseMode": "online",
        "timeRequired": "Self-paced",
        "teaches": [
            "English Grammar",
            "English Vocabulary",
            "English Conversation",
            "English Writing",
            "English Reading Comprehension"
        ]
    },

    organization: {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": SEO_CONFIG.siteName,
        "url": SEO_CONFIG.siteUrl,
        "description": SEO_CONFIG.description,
        "logo": {
            "@type": "ImageObject",
            "url": `${SEO_CONFIG.siteUrl}/logo-512x512.png`,
            "width": 512,
            "height": 512
        },
        "sameAs": [
            `https://twitter.com/${SEO_CONFIG.social.twitter}`,
            `https://facebook.com/${SEO_CONFIG.social.facebook}`,
            `https://instagram.com/${SEO_CONFIG.social.instagram}`,
            `https://linkedin.com/${SEO_CONFIG.social.linkedin}`,
            `https://youtube.com/${SEO_CONFIG.social.youtube}`
        ],
        "contactPoint": {
            "@type": "ContactPoint",
            "email": SEO_CONFIG.business.email,
            "contactType": "Customer Service"
        }
    },

    webApplication: {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": SEO_CONFIG.siteName,
        "url": SEO_CONFIG.siteUrl,
        "description": SEO_CONFIG.description,
        "applicationCategory": "EducationalApplication",
        "operatingSystem": "Any",
        "browserRequirements": "Requires JavaScript. Requires HTML5.",
        "countries": "IN, US, UK, CA, AU",
        "inLanguage": "en",
        "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD",
            "category": "Free"
        }
    }
};

// Local SEO Data (for multiple regions)
export const LOCAL_SEO = {
    india: {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": `${SEO_CONFIG.siteName} - India`,
        "url": SEO_CONFIG.siteUrl,
        "description": "Learn English online in India with AI-powered lessons, grammar practice, and conversation skills.",
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN",
            "addressLocality": "India"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": "20.5937",
            "longitude": "78.9629"
        },
        "areaServed": "India",
        "serviceArea": {
            "@type": "Country",
            "name": "India"
        }
    },

    blog: {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "My English Gurukul Blog",
        "description": "Expert English learning tips, grammar guides, vocabulary building techniques, and inspiring success stories",
        "url": `${SEO_CONFIG.siteUrl}/blog`,
        "inLanguage": "en",
        "publisher": {
            "@type": "Organization",
            "name": SEO_CONFIG.siteName,
            "url": SEO_CONFIG.siteUrl
        },
        "about": {
            "@type": "Thing",
            "name": "English Language Learning"
        },
        "keywords": "english learning, grammar tips, vocabulary building, language education, ai learning"
    },

    article: {
        "@context": "https://schema.org",
        "@type": "Article",
        "publisher": {
            "@type": "Organization",
            "name": SEO_CONFIG.siteName,
            "url": SEO_CONFIG.siteUrl,
            "logo": {
                "@type": "ImageObject",
                "url": `${SEO_CONFIG.siteUrl}/logo-512x512.png`,
                "width": 512,
                "height": 512
            }
        },
        "mainEntityOfPage": {
            "@type": "WebPage"
        },
        "inLanguage": "en",
        "audience": {
            "@type": "EducationalAudience",
            "educationalRole": "student"
        }
    }
};

// Content Categories for Sitemap
export const CONTENT_CATEGORIES = [
    {
        name: "Grammar Lessons",
        url: "/grammar",
        topics: [
            "present-tense",
            "past-tense",
            "future-tense",
            "articles",
            "prepositions",
            "conjunctions",
            "pronouns",
            "adjectives",
            "adverbs",
            "sentence-structure"
        ]
    },
    {
        name: "Vocabulary Building",
        url: "/dictionary",
        topics: [
            "basic-vocabulary",
            "intermediate-words",
            "advanced-vocabulary",
            "business-english",
            "daily-conversation",
            "academic-english"
        ]
    },
    {
        name: "Practice Exercises",
        url: "/sentences",
        topics: [
            "sentence-formation",
            "writing-practice",
            "speaking-exercises",
            "comprehension-tests"
        ]
    }
]; 